import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import FadeIn from "react-fade-in";

import NotificationItem from "../../NotificationItem";
import {
  GET_PRIORITY_NOTIFICATIONS,
  GET_RECENT_NOTIFICATIONS,
} from "../../../Routes";
import axios from "axios";
import { generateURLOptions } from "../../../URLOptions";
import { UserContext } from "../../../storage/contexts/UserContext";
import NotificationSupportActions from "./SupportActions";

const NotificationsView = () => {
  const navigate = useNavigate();
  const { profile } = useContext(UserContext);

  const [loadingNotifications, setLoadingNotifications] = useState(true);
  const [priorityNotifications, setPriorityNotifications] = useState([]);
  const [recentNotifications, setRecentNotifications] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);

  useEffect(() => {
    getPriorityNotifications();
    getRecentNotifications();
  }, []);

  const getPriorityNotifications = async () => {
    setLoadingNotifications(true);
    await axios
      .get(GET_PRIORITY_NOTIFICATIONS, {
        headers: generateURLOptions(),
      })
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }
        setPriorityNotifications(response.data?.data);
      })
      .catch((error) => {
        console.log("Get Priority Notifications Error: ", error);
        return alert(error);
      });
  };

  const getRecentNotifications = async () => {
    await axios
      .get(GET_RECENT_NOTIFICATIONS, {
        headers: generateURLOptions(),
      })
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }
        setRecentNotifications(response.data?.data);
        setTimeout(() => {
          setLoadingNotifications(false);
        }, 500);
      })
      .catch((error) => {
        console.log("Get Priority Notifications Error: ", error);
        return alert(error);
      });
  };

  const handleNotificationAction = (notification) => {
    switch (notification.notification_type) {
      case 1:
        navigate("/mood/capture");
        return;
      case 2:
        // Show the Contact Details Dialog for the requesting_user
        setSelectedNotification(notification);
        setModalOpen(!modalOpen);
        return;
      case 3:
        return;
      case 4:
        navigate("/calendar/people");
        return;
      case 5:
        // Navigate to the /questionnaires route
        navigate("/questionnaires");
        return;
      default:
        alert("No action defined for this notification type.");
        return;
    }
  };

  return (
    <>
      <NotificationSupportActions
        isOpen={modalOpen}
        onClose={() => {
          setModalOpen(!modalOpen);
        }}
        user={selectedNotification?.requested_user}
      />

      <div className="relative">
        <div
          className="z-0 absolute top-0 bottom-0 left-0 right-0"
          style={{
            background: `linear-gradient(45deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.8) 45%, ${
              profile?.company_id
                ? profile?.company_id?.company_primary_color
                : "rgba(81, 83, 245, 1)"
            } 150%)`,
          }}
        />

        {!loadingNotifications ? (
          <FadeIn className="overflow-hidden" delay={250}>
            <div className="relative z-[20] pt-12 w-full md:w-2/3 mx-auto px-6 md:px-0 pb-12">
              {/* Priority Notifications */}
              <h4 className="font-medium text-xl mb-2">Priority</h4>

              {/* Iterate through the array of Priority Notifications */}
              {priorityNotifications?.length > 0 ? (
                priorityNotifications?.map((notification, index) => (
                  <NotificationItem
                    key={notification.id}
                    notification={notification}
                    onAction={handleNotificationAction}
                  />
                ))
              ) : (
                <h5 className="font-medium text-black text-sm md:text-base mb-4">
                  No Priority Notifications are available right now
                </h5>
              )}

              {/* Recent Notifications */}
              <h4 className="font-medium text-xl mb-2">Recent</h4>

              {/* Iterate through the array of Recent Notifications */}
              {recentNotifications?.length > 0 ? (
                recentNotifications?.map((notification, index) => (
                  <NotificationItem
                    key={notification.id}
                    notification={notification}
                    onAction={handleNotificationAction}
                  />
                ))
              ) : (
                <h5 className="font-medium text-black text-sm md:text-base mb-4">
                  No Recent Notifications are available right now
                </h5>
              )}
            </div>
          </FadeIn>
        ) : (
          <>
            <FadeIn className="overflow-hidden">
              <div className="h-[90vh] relative flex flex-col justify-center items-center z-50">
                <div
                  className="h-10 w-10 rounded-full border-4 border-mpPurple/30 border-t-mpPurple animate-spin"
                  style={{ marginTop: 12, marginBottom: 12 }}
                />

                <h6 className="text-black font-medium">
                  Updating Notifications
                </h6>
              </div>
            </FadeIn>
          </>
        )}
      </div>
    </>
  );
};

export default NotificationsView;
